import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './style';
import { getSectionTheme, SECTIONS } from '../../theme/section-colors';

const SectionHeading = ({ title, section = SECTIONS.DEFAULT, boxClassName = '', ...rest }) => {
    // ** Hooks
    const classes = useStyles(getSectionTheme(section));
    return (
        <Box className={`${classes.sectionTitle} ${boxClassName}`}>
            <Typography
                component="h1"
                variant="h4"
                {...rest}
            >
                {title}
            </Typography>
        </Box>
    )
}

export default SectionHeading